function callAnn(){



$.get( "/?section_id=announcement-bar", function( data ) {
  $('#shopify-section-announcement-bar').html(data);

});


}


function getCountry(){

  const x = sessionStorage.getItem("MyLocation");
   if (!x){
setShipping();
}else{setShipping();}

}

function setShipping(){

var country =  sessionStorage.getItem("country");
var zip =   sessionStorage.getItem("zip");
var sessionItem = sessionStorage.getItem("standardShipping");

if( !sessionItem || sessionItem == 0){

  fetch( '/cart/shipping_rates.json?shipping_address[zip]=' + zip + '&shipping_address[country]=' + country, {
    credentials: 'same-origin',
    method: 'GET'
  }).then(function (response) {
    response.json().then(function (result) {
      if (response.ok) {
        var shippingRates = result['shipping_rates'][0].price / Shopify.currency.rate;
 sessionStorage.setItem("standardShipping", shippingRates);
  }
    });

  });
}
}

function set_currency() {
  $.getJSON('https://ipapi.co/json/', function(data) {
    var json = JSON.stringify(data, null, 2);
    var obj = JSON.parse(json);
    var currency = obj.currency;



    var get_currency = $("#CurrencySelector option:selected").val();

    if (get_currency != currency) {
      $("select#CurrencySelector option").each(function() {
        if (currency == $(this).val().trim()) {
          $('#CurrencySelector').val(currency).trigger('change');
        }
      });
    }
  });
}

// function CartDiscount() {
//   $('#CartDrawer, .discountsContainer').on("keydown", '.input-cart_creator_discount', function(e) {
//     if(13 === e.keyCode && "" != $(this).val()) {
//       e.preventDefault();
//       $(e.target).closest("form").find(".input-cart_discount").attr('name', 'discount1');
//       $(e.target).closest("form").find("button[name='checkout']").trigger("click");
//     }
    
//   }),
//   $(document).on("click", ".creator-discount-apply", function(e) {
//     e.preventDefault();
//     if ("" != $(e.target).closest(".CartCreatorDiscount").find(".input-cart_creator_discount").val()) {
//       $(e.target).closest("form").find(".input-cart_discount").attr('name', 'discount1');
//       $(e.target).closest("form").find("button[name='checkout']").trigger("click");
//     } 
//   })
// }

$('document').ready(function() {
  setTimeout(set_currency, 2000);
  getCountry();
  //CartDiscount();
});

// custom cart

class ProductService {
  static getBySelector(product_url) {

    return new Promise((resolve, reject) => {
      jQuery.getJSON(product_url + '.js', function(product) {
        resolve(product);
      });
    });
  }
}


class CartService {
   static getItems(timestamp) {
    return new Promise((resolve, reject) => {
      jQuery.getJSON(`/cart.js`)
        .then(res => {
          resolve(res.items)
        })
    });
  }

  static get(timestamp) {
    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: 'GET',
        url: `/cart?view=drawer&timestamp=${timestamp}&source=custom`,

        success: function(msg) {
          resolve(msg);
        },
        error: function() {
          alert(
            'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
          reject({
            message: 'Oops!'
          });
        },
      });
    });
  }

  static add(id) {
    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: id,
        },
        dataType: 'json',
        success: function(data) {
          resolve(data);
        },
        error: function() {
          alert(
            'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
          reject({
            message: 'Oops!'
          });
        },
      });
    });
  }
  static addMultipleItems(data) {
    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function(data) {
          resolve(data);
        },
        error: function() {
          alert(
            'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
          reject({
            message: 'Oops!'
          });
        },
      });
    });
  }
  static addMulti(id, quantity, theID) {

    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: quantity,
          id: id,
          properties: {
            '_id': theID,
            'Mix_Bundle': 'mix_pro'

          }



        },
        dataType: 'json',
        success: function(data) {
          resolve(data);
        },
        error: function() {
          alert(
            'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
          reject({
            message: 'Oops!'
          });
        },
      });
    });
  }
  static addMulti2(id, quantity, theID) {

    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: quantity,
          id: id,
          properties: {
            '_mid': theID

          }



        },
        dataType: 'json',
        success: function(data) {
          resolve(data);
        },
        error: function() {
          alert(
            'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
          reject({
            message: 'Oops!'
          });
        },
      });
    });
  }
  static remove(id) {

    const data = {};
    data[id] = 0;

    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: data
        },
        dataType: 'json',
        success: function(data) {
          resolve(data);
        },
        error: function() {
          alert(
            'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
          reject({
            message: 'Oops!'
          });
        },
      });
    });
  }
}

function simpleAdd(id) {
  CartService.add(id).then(data => {
ShopifyAPI.cartUpdate(data);
  });

}

function addXshot(id, quantity, theID) {
  CartService.addMulti(id, quantity, theID).then(data => {

  });

}

function addXshotCart(id, quantity, theID) {
  CartService.addMulti(id, quantity, theID).then(data => {
    addXshot2(theID, 1, theID, true);
  });

}

function addXshot2(id, quantity, theID) {
  CartService.addMulti2(id, quantity, theID).then(data => {

    ShopifyAPI.cartUpdate(data);

  });

}

function addtocart(id, modal) {
  CartService.add(id).then(data => {
    ShopifyAPI.cartUpdate(data, modal);
    $()
  });
}

// remove from cart mix


const addToRemoveItems = (obj, items, existingIDs) => {

  for (i = 0; i < items.length; i++) {

    if (items[i].properties){
    var subid = items[i].properties["_id"];

    var exists = (existingIDs.indexOf(subid) > -1);

  }else{var exists = false; var subid = false}
    if (exists == false && subid) {
      obj[items[i].key] = 0;
    }
  }

};

function specialAdd(){
    var id_flav = makeid(10);
    var tubIds = {};
$('.add_special').unbind('click');
$('.add_special').on('click', function(event){
  event.preventDefault();
  $('.add_special').prop('disabled', 'disabled');
  var productName = $("input[data-name='product_real']", this).attr('data-title');
  var dataModal = $(this).attr('data-mod');
$("input[data-name='product_ghost']", this).each(function( index ) {
  let valP = $(this).attr('value');
  let quant = $(this).attr('quantity');
  tubIds[valP] = {};
  tubIds[valP]['quantity'] = quant;
  tubIds[valP]['properties'] = {};
  tubIds[valP]['properties']['Mix_Bundle'] = "mix_pro";
  tubIds[valP]['properties']['BundleItem'] = productName;
  tubIds[valP]['properties']['_id'] = id_flav;
});

let realProduct = $("input[data-name='product_real']", this).attr('value');
tubIds[realProduct] = {};
tubIds[realProduct]['quantity'] = 1;
tubIds[realProduct]['properties'] = {};
tubIds[realProduct]['properties']['_mid'] = id_flav;
//tubIds[realProduct]['properties']['orginalPrice'] = $("input[data-name='product_real']", this).attr('data-compare') / Shopify.currency.rate;




const addData = {
  items: []
}
const keys = Object.keys(tubIds);
keys.forEach(k => {
if (tubIds[k]['properties']['_id']){
addData.items.push({
  quantity: tubIds[k]["quantity"],
  id: k,
  properties: {
    '_id': tubIds[k]['properties']['_id'],
    'Mix_Bundle': 'mix_pro',
    'Main Bundle' : tubIds[k]['properties']['BundleItem']
  }
});
}else{
addData.items.push({
  quantity: tubIds[k],
  id: k,
  properties: {
    '_mid': tubIds[k]['properties']['_mid']

  }
});
}

});

CartService.addMultipleItems(addData).then(data => {


  ShopifyAPI.cartUpdate(data, dataModal);
  $('.add_special').prop('disabled', false);

});

});

}

function clearcart(hid) {

  var toRemove = {};
  var existingIDs = new Array();
  CartService.getItems()
    .then(items => {
      if (Array.isArray(items) && items.length > 0) {
        for (i = 0; i < items.length; i++) {
          if (items[i].properties){
          if (items[i].properties["_mid"]) {
            existingIDs.push(items[i].properties["_mid"]);


          }
}
        }

        addToRemoveItems(toRemove, items, existingIDs);
      }
      if (Object.keys(toRemove).length > 0) {
        jQuery.post('/cart/update.js', {
          updates: toRemove,
          dataType: "json",
          success: function(response) {

          if(hid == "submit"){  $('.cart').submit();}
          }
        });
      }else{
            if(hid == "submit"){  $('.cart').submit();}
      }



    })
}

function removeDrawer(id, mix, location, hid) {



  CartService.remove(id).then(data => {
    if (data) {
      if (mix == 'disabled') {
        if (hid > 0) clearcart(hid);
        else {
          clearcart();
        }
      }

      CartService.get(Date.now()).then(data => {

        if (location == 'cart') {
          window.location.href = "/cart";
        } else {
          ShopifyAPI.cartUpdate(data);
        }




      });

    }
  });


}

function rendercart() {


  CartService.get(Date.now()).then(data => {

    ShopifyAPI.cartUpdate(data);
    checkoutFailsafe();
    $('.mine_add').val("Add to cart");
    $(".flavor_select").attr("style", "");
    $(".arr").attr("style", "");
    $(".flavor_select").val($(".flavor_select option:first").val());
    $('.selected-flavors').remove();
    // Enable/disable cart button (and messages if needed)
    var flavour_counts = $('#variety_box').data('flavorcounts');

    $('#AddToCart').addClass('inactive').prop('disabled', true);
    $('#AddToCart').attr("value", "PICK " + (flavour_counts - 0) + " MORE");
  });
  $('.variety_box_preview').html("");

}


function tabMargin() {

  $('.big-content-click').on('click', function() {

    var x = $('.big-content-click').offset().left * -1;
    $('.big-content-wrapper_tabs').css("margin-left", x);
  });

}

$(document).ready(function() {
  specialAdd();
  checkoutFailsafe();
  tabMargin();
  if (theme.settings["automaticRecommended"]) {
    renderCartRecommendations();
  }
});


function isMobile() {
  const width = $(window).width();
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : width < 1025;
  return isMobile;
}

function fetchRecommendations(productId, recommendationsCount = 10) {
var small = theme.settings.smallItem_count,
    medium = theme.settings.mediumItem_count,
    large = theme.settings.largeItem_count,
    disabled = theme.settings.disabledItem_count;
    if (disabled == 0){
if(theme.settings['complexRecommended']){

if(large > 0 && large < 3  ){

  var url = `/recommendations/products?section_id=coll_rec_mob_small_1&product_id=${productId}&limit=${recommendationsCount}`;
  return fetch(url)
}else if ((large >= 3 || large == 0 ) && medium >= 0){

  var url = `/recommendations/products?section_id=coll_rec_mob_small_2&product_id=${productId}&limit=${recommendationsCount}`;
  return fetch(url)
}else if(large == 0 && medium == 0 && small > 0){
  var url = `/recommendations/products?section_id=coll_rec_mob_small_2&product_id=${productId}&limit=${recommendationsCount}`;
  return fetch(url)
}else{
  var url = `/recommendations/products?section_id=coll_rec_mob&product_id=${productId}&limit=${recommendationsCount}`;
  return fetch(url)
}
}else{
  var url = `/recommendations/products?section_id=coll_rec_mob&product_id=${productId}&limit=${recommendationsCount}`;
  return fetch(url)
}
}


}

function renderCartRecommendations(openModal) {

  CartService.getItems()
    .then(items => {

      if (Array.isArray(items) && items.length > 0) {
        const product = items[0];

        return fetchRecommendations(product.product_id)

      }else{
          throw new Error('Something went wrong');
      }

    })
    .then(
      response => response.text().then(recommendations => {
        var modal = $(recommendations).find('#add-3x-tub');

        if (modal.length > 0){
          $('#add-3x-tub').replaceWith(modal);
        }

        if(openModal){$('#add-3x-tub').attr('aria-hidden', false);}
        var $rec = $(recommendations);
        var recRender = $rec.find('#CollectionRecommendation__Cart');
        $('#CustomCart__Recommendations-mob').html(recRender);
        specialAdd();

      })
      .catch(error => {
        console.log(error)
      })
    )
}



function checkoutFailsafe() {
  $('.cart__checkout').on('click', function(e) {
    e.preventDefault();

   clearcart("submit");




  });

}



function makeid(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}


$(document).ready(function() {

  if ($('.qty-adjust.qty-plus').length == 2) {
    $('.qty-adjust.qty-plus:eq(1)').hide();
  }
  $('.button--atc--coll').on('click', function() {
    const z = $(this).attr("data-cid");
    const theID = $(this).attr("data-id");

    setTimeout(function() {

      addXshot(z, 3, theID);
    }, 500);


  });
  toggleMenuImage();
  toggleMobileMenu();
  moveReviews();
});


function moveReviews() {
  if (isMobile()) {
    $('#ReviewsWidget').insertAfter('.shopify-payment-button');

  }
}

function toggleMobileMenu() {
  $('.mobile-nav__has-sublist').on('click', function(e) {
    e.preventDefault();
    const id = $(".toggle_drawer", this).attr('data-open');

    $('#' + id + '_open').attr('aria-hidden', false);
    $('.drawer__back').attr('data-open', id);

  });

  $('.toggle_drawer').on('click', function() {

    const id = $(this).attr('data-open');
    $('#' + id + '_open').attr('aria-hidden', false);
    $('.drawer__back').attr('data-open', id);

  });

  $('.drawer__back').on('click', function() {

    var id = $(this).attr('data-open');
    if (id) {

      $('#' + id + '_open').attr('aria-hidden', true);
      $('.drawer__back').attr('data-open', 'shop-now');
      if (id == 'shop-now') {
        $('.drawer__back').attr('data-open', false);
      }

    }
  });
}

function toggleMenuImage() {

  $('.Mega__Menu--links ul li').hover(
    function() {

      const aria_control = $('.mega__menu--dropdown_links', this).attr('aria-controls');

      const dataID = $(this).attr('data-id');

      var myID = '#' + dataID + "_open";
      $(myID).toggleClass('openItem');
    },
    function() {
      const dataID = $(this).attr('data-id');
      var myID = '#' + dataID + "_open";
      $(myID).toggleClass('openItem');
    }
  );


  $('.menu-grid-item-links li a').on({
    mouseenter: function () {
      const handle = $(this).data('handle');
      const $img = $(`#${handle}_open`).addClass('openItem');
    },
    mouseleave: function () {
      const handle = $(this).data('handle');
      const $img = $(`#${handle}_open`).removeClass('openItem');
    }
  });



  $('.mega__menu--dropdown_links').hover(
    function() {

      const dataID = $(this).attr('data-id');

      var myID = '#' + dataID + "_open";
      $(myID).toggleClass('openItem');
      const aria_control = $(this).attr('aria-controls');
      $('#' + aria_control).toggleClass('openItem');
    },
    function() {
      const dataID = $(this).attr('data-id');
      var myID = '#' + dataID + "_open";
      $(myID).toggleClass('openItem');
      const aria_control = $(this).attr('aria-controls');
      $('#' + aria_control).toggleClass('openItem');
    }
  );


  $('.Childre__Hidden').hover(
    function() {
      $(this).addClass('openItem');
    },
    function() {

      $(this).removeClass('openItem');
    }
  );

}


/* TUBZ DISCOUNTS */
$('button[data-modal="add-tub"]').on('click',function(e){
e.preventDefault();
var choosenIdG = $(this).attr('data-cid');
var choosenId = $(this).attr('data-id');
var nameId = $(this).attr('data-name');
var name = nameId.replace(/ *\([^)]*\) */g, "");
theme.settings.nameOfItem = name;
openModal(this, choosenIdG, choosenId);

});

/* QUICK MEALS BOGO */
$('button[data-modal="add-quick-meal"]').on('click',function(e){
  e.preventDefault();
  var choosenIdG = null;
  var choosenId = $(this).attr('data-id');
  openModal(this, choosenIdG, choosenId);
});
  


$(document).on('click','button[data-action="close-modal"]',function(e){
  if($(this).attr('data-id')){
    e.preventDefault();
    simpleAdd($(this).attr('data-id'));
    closeModal(this);
  }else{

    e.preventDefault();
    closeModal(this);
  }


});

$(document).on('click','.no-thanks', function(e) {
   $('#add-3x-tub').prepend('<div class="loader"><div class="loader_spin"></div></div>');
    $('.cart').submit();

});



$('.tub_selector').on('change', function() {
  el = $(this);
  xtubUpsell(el);
});

$('.quick_meal_selector').on('change', function() {
  el = $(this);
  quickMealBogo(el);
});

function getImageSrc(product_url){



}
function makeid(length) {
   var result           = '';
   var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
   var charactersLength = characters.length;
   for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}

function xtubUpsell(el){
  if ($('.tub_selector[name="tubz1"] :selected').val() != 'none'){
  $('.tub_selector[name="tubz2"]').attr('disabled',false);
 $('.second__modal').removeClass('disabled');
}else{

  if (theme.settings['third_item'] == true ){
    $('.tub_selector[name="tubz2"]').val("none");
      $('.tub_selector[name="tubz2"]').attr('disabled',true);
 $('.second__modal').addClass('disabled');
  var url = $('.tub_selector[name="tubz2"] :selected').attr('data-url');
   $(".tubz2").attr("src", url);}

   $('.add-all-to-cart').attr('disabled', true);

  }


const items = [];
  var tubIDs = {};
var tubID_fourth;
const tubURL_first = $('.tub_selector[name="tubz1"] :selected').attr('data-url');
const tubID_first = $('.tub_selector[name="tubz1"] :selected').attr('data-id');
var tubName_first = $('.tub_selector[name="tubz1"] :selected').val();
 tubName_first  = tubName_first.replace(/ *\([^)]*\) */g, "");

var tubUrl_second = "",
  	tubID_second = "",
    tubName_second ="";
if (theme.settings['third_item'] == true ){
 tubUrl_second = $('.tub_selector[name="tubz2"] :selected').attr('data-url');
 tubID_second = $('.tub_selector[name="tubz2"] :selected').attr('data-id');
 tubName_second = $('.tub_selector[name="tubz2"] :selected').val();
 tubName_second  = tubName_second.replace(/ *\([^)]*\) */g, "");
}

const tubUrl_third = $('[data-name="first-item"]').attr('data-url');
const tubID_third = $('[data-name="first-item"]').attr('data-cid');
var tubName_third = theme.settings.nameOfItem;

 tubName_third  = tubName_third.replace(/ *\([^)]*\) */g, "");



url = $(":selected", el).attr('data-url');
const imageElement = $(el).attr("name");
$("."+imageElement).attr("src", url);

  var id_flav = makeid(10);

if(tubURL_first){
  tubIDs[tubID_first] = {};
    tubIDs[tubID_first]['properties'] = {};
}
 if(tubID_second){
 tubIDs[tubID_second] = {};
     tubIDs[tubID_second]['properties'] = {};
}



tubIDs[tubID_first]['quantity'] = 1;
tubIDs[tubID_first]['properties']['Mix_Bundle'] = "mix_pro";
tubIDs[tubID_first]['properties']['_id'] = id_flav;
  tubIDs[tubID_third] = {};
  if(tubID_first == tubID_third && tubID_first == tubID_second){
    tubIDs[tubID_first]['quantity'] = 3;
  }else if(tubID_first == tubID_third || tubID_second == tubID_first){
      tubIDs[tubID_first]['quantity'] = 2;
  }else{
      tubIDs[tubID_first]['quantity'] = 1;
  }



 tubIDs[tubID_third]['properties'] = {};
tubIDs[tubID_third]['properties']['_id'] = id_flav;
tubIDs[tubID_third]['properties']['Mix_Bundle'] = "mix_pro";

 if (tubID_second){
    if(tubID_second == tubID_third && tubID_second == tubID_first){
      tubIDs[tubID_second]['quantity'] = 3;
    }else if(tubID_second == tubID_third || tubID_second == tubID_first){
        tubIDs[tubID_second]['quantity'] = 2;
    }else{
        tubIDs[tubID_second]['quantity'] = 1;
    }

  tubIDs[tubID_second]['properties']['Mix_Bundle'] = "mix_pro";
  tubIDs[tubID_second]['properties']['_id'] = id_flav;

 }




 // Get the size of an object

if(tubID_second > 0){
tubID_fourth = parseInt(theme.settings.threeItems);
tubID_fourth_price = parseInt(theme.settings.threeItems_price) * 100;


}
else if (tubID_first > 0){

  tubID_fourth = parseInt(theme.settings.twoItems);
  tubID_fourth_price = parseInt(theme.settings.twoItems_price) *100;



}



tubIDs[tubID_fourth] = {};
tubIDs[tubID_fourth]['quantity'] = 1;

tubIDs[tubID_fourth]['properties'] = {};


tubIDs[tubID_fourth]['properties']['Flavor0'] =tubName_third;
tubIDs[tubID_fourth]['properties']['Flavor1'] = tubName_first;
if(tubID_second > 0){tubIDs[tubID_fourth]['properties']['Flavor2'] = tubName_second;}
//tubIDs[tubID_fourth]['properties']['orginalPrice'] = tubID_fourth_price;
tubIDs[tubID_fourth]['properties']['_mix'] = true;
tubIDs[tubID_fourth]['properties']['ID'] = "1000";
tubIDs[tubID_fourth]['properties']['_mid'] = id_flav;
tubIDs[tubID_fourth]['properties']['_id'] = id_flav;



var $addToCart = $('.add-all-to-cart');
theme.settings.string = tubIDs;
let svg = '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 3.5H3V21.5H21V3.5ZM10 17.5L5 12.5L6.41 11.09L10 14.67L17.59 7.08L19 8.5L10 17.5Z" fill="white"/></svg>'
var button = `<div class='Modal__Close add-all-to-cart' data-ids>`+svg+`Add to cart</div>`;
if ($('.tub_selector[name="tubz1"] :selected').val() != 'none'){
  $addToCart.replaceWith(button);
}

addAllToCart();
}


function quickMealBogo(el){
  const items = [];
  var tubIDs = {};
  const currentQuickMealId = $('#currently_selected_quick_meal').attr('data-id');
  const tubURL_first = $('.quick_meal_selector[name="quickmeal1"] :selected').attr('data-url');
  const tubID_first = $('.quick_meal_selector[name="quickmeal1"] :selected').attr('data-id');
  var tubName_first = $('.quick_meal_selector[name="quickmeal1"] :selected').val();
  tubName_first  = tubName_first.replace(/ *\([^)]*\) */g, "");
  url = $(":selected", el).attr('data-url');
  const imageElement = $(el).attr("name");
  $("."+imageElement).attr("src", url);

  if (tubID_first) {
    $('.add-all-to-cart.quick-meal-add-to-cart').attr('disabled', false);
  }

  if(tubURL_first){
    tubIDs[currentQuickMealId] = {};
    tubIDs[tubID_first] = {};
  }
  if(currentQuickMealId === tubID_first) {
    tubIDs[currentQuickMealId]['quantity'] = 2;
  } else {
    tubIDs[tubID_first]['quantity'] = 1;
    tubIDs[currentQuickMealId]['quantity'] = 1;  
  }

  theme.settings.string = tubIDs;
  addAllToCart();

}


$(document).on('click','.add-all-to-cart-final',function(){
  addFinalItems();
  $('#add-3x-tub').prepend('<div class="loader"><div class="loader_spin"></div></div>');
});

function addFinalItems(){
    var tubIDs = {};
  $( "#add-3x-tub .cart_featured" ).each(function( index ) {
    var mainID = $(this).attr('data-all-id');
    var ghostID = $(this).attr('data-all-shot');
     if (ghostID){
       tubIDs[mainID] = {};
       tubIDs[mainID]['ghost'] = ghostID;
       tubIDs[mainID]['quanity'] = 1;
       tubIDs[mainID]['gquantity'] = 3;

     }else{
        tubIDs[mainID] = 1;
     }




  });
  const addData = {
    items: []
  }
  const keys = Object.keys(tubIDs);
  keys.forEach(k => {
if (tubIDs[k]['ghost']){
  addData.items.push({
    quantity: 3,
    id: tubIDs[k]['ghost'],
    properties: {
      '_id': k,
      'Mix_Bundle': 'mix_pro'
    }
  });
  addData.items.push({
    quantity: tubIDs[k],
    id: k,
    properties: {
      '_mid': k

    }
  });
}else{
  addData.items.push({
    quantity: tubIDs[k],
    id: k
  });
}

  });

  CartService.addMultipleItems(addData).then(data => {


    ShopifyAPI.cartUpdate(data);
      var $getPageOverlay = $('.overlay-drawer');
      $getPageOverlay.prepend('<div class="loader"></div>')
       $('.cart').submit();

  });

}


function addAllToCart(){
  $('.add-all-to-cart').on('click', function(){
    const addData = {
      items: []
    }
    let data = theme.settings.string;

    const keys = Object.keys(data);
    keys.forEach(k => {

      addData.items.push({
        quantity: data[k]['quantity'],
        properties: data[k]['properties'],
        id: k
      });
    });
    CartService.addMultipleItems(addData).then(data => {

      ShopifyAPI.cartUpdate(data);
      closeModal('#add-quick-meal');
      closeModal('#add-tub');

    });

  });


}

function initateFinalPopup(modal){

  if(modal){
    openModal($('.cart__checkout'));
  }

  $('.cart__checkout').on('click', function(e) {
    e.preventDefault();
    clearcart();

if($('#add-3x-tub .cart_featured').length > 0){
  openModal(this);
}else{
    clearcart("submit");
}




  });

}

function openModal(data, choosenId, id){
  var getModalSelector = $(data).attr('data-modal');
  if (getModalSelector == "add-tub") {
    $("[data-name='first-item']").remove();
    $(".no-tnx").attr('data-id', id);
    $('#add-tub').append("<input type='hidden' class='test' data-name='first-item' data-cid = "+choosenId+"></input>");
    if (theme.settings['first_item_as_current'] == true){
      var img_src = $(data).attr('data-url');
      var name = $(data).attr('data-rname');
      $('#currently_selected').html(name);
      $('.tubz_current').attr("src", img_src);
      $('.f_wo_dc').text($(data).data('price-fortmated'));
    }
  }

  if (getModalSelector == "add-quick-meal") {
    $("[data-name='first-item']").remove();
    $(".no-tnx").attr('data-id', id);
    
    $('#add-quick-meal').append("<input type='hidden' class='test' data-name='first-item' data-cid = "+choosenId+"></input>");
    
    //if (theme.settings['first_item_as_current_quick_meal'] == true) {
      var img_src = $(data).data('url');
      var name = $(data).data('rname');
      $('#currently_selected_quick_meal').html(name);
      $('#currently_selected_quick_meal').attr('data-id', id);
      $('.quick-meal-bogo-price').text($(data).data('price'));
      $('.quick_meal_current').attr("src", img_src);
    //}
  }

  var $getPageOverlay = $('.overlay-drawer');
  $('#'+getModalSelector).attr("aria-hidden", "false");
  $getPageOverlay.addClass('modal-open');
  $getPageOverlay.on('click', function (e) {
    if ($('.Modal[aria-hidden="false"]').length > 0) {

      if($('.Modal[aria-hidden="false"]').attr('id') == "add-tub"){
        $('.no-tnx').click();

      }
      else if($('.Modal[aria-hidden="false"]').attr('id') == "add-quick-meal"){
        $('.no-tnx').click();

      } else{
          closeModal('.Modal');
      }

    }
  });
}

function closeModal(data){
  var $getModalSelector = $(data).closest('.Modal');
  var getModalId = $getModalSelector.attr('id');

  if (getModalId == "add-tub"){
    if ($('.tub_selector[name="tubz1"]').val() != 'none' ) {  
      $('.tub_selector[name="tubz2"]').val('none').trigger("change");
      $('.tub_selector[name="tubz1"]').val('none').trigger("change");
    }
  }
  if (getModalId == "add-quick-meal") {
    if ($('.quick_meal_selector[name="quickmeal1"]').val() != 'none' ) {  
      $('.quick_meal_selector[name="quickmeal1"]').val('none').trigger("change");
      $('.add-all-to-cart.quick-meal-add-to-cart').attr('disabled', true);
    }
  }
  var $getPageOverlay = $('.overlay-drawer');
  $getModalSelector.attr("aria-hidden", "true");
  $getPageOverlay.removeClass('modal-open');
  $('.cart__checkout').removeClass("bndlr-checkout-button-clicked btn--loading")
}



$('.select ul li.option').click(function() {
  $(this).siblings().addBack().children().remove();
  var a = $(this).siblings().toggle();
  $(this).parent().prepend(this);
})